import { render } from "./WaHeader.vue?vue&type=template&id=91f1aa76"
import script from "./WaHeader.vue?vue&type=script&lang=js"
export * from "./WaHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__